<template>
  <div class="rang-rank" v-show="cars.length > 0"
    :class="{'rang-rank--mobile': deviceType === 'mobile'}">
    <div class="rang-rank__container">
      <!-- 标题栏 -->
      <div class="rang-rank__header">
        <div class="rang-rank__title-group">
          <h2 class="rang-rank__title">Rang Rank</h2>
          <div class="rang-rank__switcher" v-if="deviceType !== 'mobile'">
            <div class="rang-rank__switch" @click="prevPage"
              :style="{ opacity: currentPage === 0 ? 0.5 : 1 }">
              <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12"
                fill="none">
                <path
                  d="M1.81151 6L5.78094 1.46355C6.07302 1.12975 6.07302 0.584148 5.78094 0.250349C5.48887 -0.0834497 5.01146 -0.0834497 4.71938 0.250349L0.218581 5.39407C0.145855 5.47718 0.0907245 5.5737 0.0543615 5.67693C-0.00898042 5.8579 -0.0171914 6.05898 0.0309015 6.24532C0.0379395 6.27213 0.0461505 6.2976 0.0543615 6.32441C0.0907245 6.42764 0.145855 6.52416 0.218581 6.60727L4.71821 11.7497C5.01028 12.0835 5.48769 12.0835 5.77977 11.7497C6.07185 11.4159 6.07185 10.8702 5.77977 10.5364L1.81151 6Z"
                  fill="white" />
              </svg>
            </div>
            <div class="rang-rank__switch" @click="nextPage"
              :style="{ opacity: currentPage === maxPage ? 0.5 : 1 }">
              <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12"
                fill="none">
                <path
                  d="M4.18849 6L0.219058 1.46355C-0.073019 1.12975 -0.073019 0.584148 0.219058 0.250349C0.511134 -0.0834497 0.988545 -0.0834497 1.28062 0.250349L5.78142 5.39407C5.85414 5.47718 5.90928 5.5737 5.94564 5.67693C6.00898 5.8579 6.01719 6.05898 5.9691 6.24532C5.96206 6.27213 5.95385 6.2976 5.94564 6.32441C5.90928 6.42764 5.85414 6.52416 5.78142 6.60727L1.28179 11.7497C0.989717 12.0835 0.512307 12.0835 0.22023 11.7497C-0.0718465 11.4159 -0.0718465 10.8702 0.22023 10.5364L4.18849 6Z"
                  fill="white" />
              </svg>
            </div>
          </div>
        </div>
        <a class="rang-rank__view-more" :href="getHrefForAll()">
          <span>View More</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="10" viewBox="0 0 24 10"
            fill="none">
            <path
              d="M19.6112 10H16.3112C16.0733 10 15.9535 9.66313 16.1219 9.46625L19.9432 5L16.1214 0.533125C15.9529 0.336875 16.0727 0 16.3107 0H19.6106C19.8235 0 20.0272 0.0987495 20.178 0.274374L23.8432 4.55812C24.0523 4.8025 24.0523 5.19813 23.8432 5.44188L20.1785 9.725C20.0277 9.90125 19.824 10 19.6112 10ZM4.13548 9.725L7.80012 5.44188C8.00921 5.1975 8.00921 4.80187 7.80012 4.55812L4.13494 0.274374C3.98468 0.0987495 3.78094 0 3.56811 0H0.268158C0.0301937 0 -0.0895905 0.336875 0.078856 0.53375L3.90019 5L0.078856 9.46625C-0.0895905 9.66313 0.0296589 10 0.268158 10H3.56811C3.78094 10 3.98521 9.90125 4.13548 9.725ZM12.1567 9.725L15.8214 5.44188C16.0305 5.1975 16.0305 4.80187 15.8214 4.55812L12.1562 0.274374C12.0065 0.0987495 11.8022 0 11.5894 0H8.28942C8.05146 0 7.93167 0.336875 8.10012 0.53375L11.922 5L8.10065 9.46625C7.93221 9.66313 8.05146 10 8.28942 10H11.5894C11.8027 10 12.0065 9.90125 12.1567 9.725Z"
              fill="#e2372d" />
          </svg>
        </a>
      </div>

      <!-- 内容区域 -->
      <div class="rang-rank__grid">
        <a v-for="(car, index) in displayedCars" :key="index" class="rang-rank__card"
          :href="getHrefForDetail(car)">
          <div class="rang-rank__card-img-wrapper">
            <img :src="car.image" class="rang-rank__card-img" :alt="car.model">
            <div class="rang-rank__card-logo-box">
              <img :src="car.logo" class="rang-rank__card-logo" :alt="car.brand">
            </div>
          </div>

          <div class="rang-rank__card-content">
            <div class="rang-rank__card-info">
              <p class="rang-rank__card-brand">{{ car.brand }}</p>
              <h3 class="rang-rank__card-title">{{ car.model }}</h3>
            </div>
            <div class="rang-rank__speed-badge">
              <span class="rang-rank__speed-val">{{ car.speedValue }}</span>
              <span class="rang-rank__speed-label">0-60-MPH</span>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CarRangRank',
  data () {
    return {
      cars: [],
      currentPage: 0,
      pageSize: 3
    }
  },
  computed: {
    ...mapGetters(['deviceType', 'domainConfig']),
    displayedCars () {
      if (this.deviceType === 'mobile') return this.cars.slice(0, 3);
      const start = this.currentPage * this.pageSize;
      return this.cars.slice(start, start + this.pageSize);
    },
    maxPage () {
      return Math.ceil(this.cars.length / this.pageSize) - 1;
    }
  },
  mounted () {
    this.fetchRangRankData();
  },
  methods: {
    async fetchRangRankData () {
      try {
        const themeFilters = this.domainConfig?.themeFilters || {};
        const webIndex = this.domainConfig?.webIndex || 1;
        const params = { ...themeFilters, webIndex };
        const res = await this.$global.server.getRecommendedRangRank(params);
        if (res.code === 200) {
          this.cars = (res.data || []).map(item => {
            const photos = item.photos ? item.photos.split(',') : [];
            return {
              id: item.id,
              model: item.name,
              brand: item.brand,
              logo: item.logoUrl ,
              image: item.cover || photos[0],
              speedValue: item.accelerationTime ? `${item.accelerationTime}s` : '-'
            };
          });
        }
      } catch (error) {
        console.error('[CarRangRank] fetch error:', error);
      }
    },
    prevPage () { if (this.currentPage > 0) this.currentPage--; },
    nextPage () { if (this.currentPage < this.maxPage) this.currentPage++; },
    getHrefForAll () {
      const channel = this.$route.params.channel;
      return channel ? `/${channel}/car-list` : '/car-list';
    },
    getHrefForDetail (car) {
      const channel = this.$route.params.channel;
      const name = encodeURIComponent((car.model || '').replace(/\s+/g, '-'));
      return channel ? `/${channel}/cars/${name}/${car.id}` : `/cars/${name}/${car.id}`;
    }
  }
}
</script>

<style lang="scss">
@import '~@/css/variables.scss';

.rang-rank {
	background: #000;
	padding: rem(60) rem(180);
	width: 100%;
	box-sizing: border-box;

	&__container {
		width: 100%;
	}

	&__header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: rem(30);
	}

	&__title-group {
		display: flex;
		align-items: center;
		gap: rem(20);
	}

	&__title {
		color: #ffffff;
		font-family: 'Inter-ExtraBold', sans-serif;
		font-size: rem(24);
		font-weight: 800;
		margin: 0;
	}

	&__switcher {
		display: flex;
		gap: rem(12);
	}

	&__switch {
		width: rem(24);
		height: rem(24);
		background: #e2372d;
		border-radius: rem(8);
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		transition: all 0.3s ease;

		&:hover {
			opacity: 0.8;
		}
	}

	&__view-more {
		display: flex;
		align-items: center;
		gap: rem(12);
		text-decoration: none;
		span {
			color: #e2372d;
			font-family: 'Inter-ExtraBold', sans-serif;
			font-size: rem(14);
			font-weight: 800;
		}
	}

	&__grid {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: rem(20);
	}

	&__card {
		background: linear-gradient(180deg, rgba(226, 55, 45, 0) 0%, rgba(226, 55, 45, 0.2) 100%);
		border-radius: rem(16);
		border: 1px solid rgba(255, 255, 255, 0.1);
		overflow: hidden;
		text-decoration: none;
		transition: all 0.3s ease;
		display: flex;
		flex-direction: column;
		box-shadow: 0 rem(4) rem(12) rgba(0, 0, 0, 0.24);

		&:hover {
			transform: translateY(-5px);
			border-color: rgba(226, 55, 45, 0.5);
		}
	}

	&__card-img-wrapper {
		position: relative;
		height: rem(200);
		padding: rem(8);
	}

	&__card-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: rem(12);
		border: 1px solid rgba(255, 255, 255, 0.1);
	}

	&__card-logo-box {
		position: absolute;
		top: rem(8);
		left: rem(8);
		width: rem(32);
		height: rem(32);
		background: #fff;
		border-radius: rem(12) 0 rem(12) 0;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: rem(2);
		box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.32);
	}

	&__card-logo {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	&__card-content {
		padding: rem(12) rem(20) rem(20);
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	&__card-info {
		display: flex;
		flex-direction: column;
		gap: rem(4);
		flex: 1;
		min-width: 0;
	}

	&__card-brand {
		color: rgba(255, 255, 255, 0.5);
		font-size: rem(12);
		margin: 0;
		overflow: hidden;
		color: #fff;
		text-overflow: ellipsis;
		font-family: Inter;
		font-style: normal;
		font-weight: 400;
		line-height: rem(12); /* 100% */
	}

	&__card-title {
		color: #ffffff;
		font-family: 'Inter-ExtraBold', sans-serif;
		font-size: rem(16);
		font-weight: 800;
		margin: 0;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	&__speed-badge {
    background: linear-gradient(180deg, #E2372D 0%, rgba(226, 55, 45, 0.00) 100%);

		border-radius: rem(12);
		padding: rem(6) rem(12);
		display: flex;
		flex-direction: column;
		align-items: center;
		box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.24);
	}

	&__speed-val {
		color: #ffffff;
		font-family: 'Inter-ExtraBold', sans-serif;
		font-size: rem(16);
		font-weight: 800;
		line-height: 1;
	}

	&__speed-label {
		color: rgba(255, 255, 255, 0.7);
		font-size: rem(8);
		margin-top: rem(2);
	}
}

// PC端
.detect_deviece_pc,
.detect_deviece_desktop {
	.rang-rank {
		padding: rem(60) rem(180);
		&__grid {
			grid-template-columns: repeat(3, 1fr);
		}
	}
}

// 移动端
.detect_deviece_mobile {
	.rang-rank {
		padding: rem(60) 0 rem(60) rem(16);
		&__header {
			padding-right: rem(16);
		}
		&__grid {
			display: flex;
			flex-direction: column;
			gap: rem(20);
			padding-right: rem(16);
		}
		&__card {
			width: 100%;
			flex-shrink: 0;
		}
	}
}
</style>